import { render } from "./PageModalPenanganan.vue?vue&type=template&id=de9b0240"
import script from "./PageModalPenanganan.vue?vue&type=script&lang=js"
export * from "./PageModalPenanganan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__